<template>
	<nk-page commercialAccess="System" :policyClaims="['General_FiscalPeriod_List']" :buttons="[button_refresh]">
		<template #badges>
			<nk-badge system="accounting">
				<nk-badge-item type="system" modelValue="accounting"></nk-badge-item>
				<nk-badge-item type="system" modelValue="accounting" :title="$t(`forms.FiscalPeriod`)"></nk-badge-item>
			</nk-badge>
		</template>
		<div class="company-list h-100">
			<div class="d-flex h-100 flex-column">
				<div class="row headers-row h-100 overflow-auto">
					<div class="col col-12 col-sm-4 h-100 col-companies">
						<div class="card nk-card p-0 h-100" ref="companiesWaitingZone">
							<div class="card-header">{{ $t('company.companies') }}</div>
							<div class="card-body h-100">
								<div class="h-100 d-flex flex-column">
									<div class="form-group">
										<input type="text" class="form-control" ref="company-search-input" v-model="companySearchKeyword" @input="companySearchKeywordChanged" :placeholder="$t('company.search-company-name')" :tabindex="101" />
									</div>
									<div class="side-content company-list-content no-focus" tabindex="102" startup ref="company-list-content">
										<ul class="tiles">
											<li v-for="item in filteredCompanies" :key="item.id" :id="item.id" :data-id="item.id" @click="selectCompany(item)" class="row no-gutters company-tile flex-column" :class="{ selected: item === selectedCompany }">
												<div class="col h-100 info cursor-pointer">
													<img :src="item.imageUrl || companyImage" class="circle company-img">
													<div class="mr-3">
														<h3 class="company-name"> {{ item.name }}</h3>
														<div class="d-flex">
															<span class="prop">
																<!-- <span>{{ $t('company.f.city') }}:</span> &nbsp; -->
																<strong>{{ item.nationalCode }}</strong>
															</span>
															<!-- <span class="prop">
																<span>{{ $t('company.f.type') }}:</span> &nbsp;
																<strong>{{ $t("IdentityTypes." + (item.type.toLowerCase())) }}</strong>
															</span> -->
														</div>
													</div>
												</div>
												<div class="col-auto h-100 buttons d-flex justify-content-end">
													<button @click="editCompany(item)" v-if="$nikan.checkPermission('General_Company_Edit')">
														<icon :icon="['fas', 'edit']" />
													</button>
													<button v-if="$nikan.checkPermission(['General_ChangeLog_List'])" @click="companyChangeLog(item)">
														<icon :icon="['fas', 'scroll']" />
													</button>
													<button @click="deleteCompany(item)" class="delete-btn" v-if="$nikan.checkPermission('General_Company_Delete')">
														<icon :icon="['fas', 'trash-alt']" />
													</button>
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col col-12 col-sm-8 h-100 col-fiscals">
						<div class="card nk-card p-0 h-100" ref="fiscalsWaitingZone">
							<div class="card-header" v-html="$t('fiscal.fiscals', { company: (selectedCompany || {}).name || '' })"></div>
							<div class="card-body h-100">
								<div class="h-100 d-flex flex-column">
									<!-- <div class="form-group">
										<input type="text" class="form-control" v-model="fiscalSearchKeyword" ref="fiscal-search-input" :placeholder="$t('fiscal.search-fiscal-name')" :tabindex="103" />
									</div> -->
									<div class="side-content fiscal-list-content h-100">
										<ag-grid :options="fiscalGridOptions" :data="filteredFiscals" :key="filteredFiscals.length" @preSelectedRowData="(data) => fiscalGridSelectedRow = data" tabindex="101" ref="fiscalTable" startup></ag-grid>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<context-menu :target="fiscalTable">
				<menu-item :title="$t('fiscal.new-fiscal')" v-if="$nikan.checkPermission(['General_FiscalPeriod_Add'])" :handler="tryAddNewFiscalPeriod" icon="plus" :shortcut="shortcuts.fiscalInsert"></menu-item>
				<menu-splitter></menu-splitter>
				<menu-item :title="$t('edit')" v-if="$nikan.checkPermission(['General_FiscalPeriod_Edit'])" :handler="editCurrentFiscalPeriod" icon="edit" :shortcut="shortcuts.edit"></menu-item>
				<menu-item :title="$t('delete')" v-if="$nikan.checkPermission(['General_FiscalPeriod_Delete'])" :handler="() => { deleteFiscal(fiscalGridSelectedRow) }" icon="trash" iconCss="red-icon" :shortcut="shortcuts.delete"></menu-item>
				<menu-item :title="$t('operationRole.claims')" v-if="$nikan.checkPermission('General_Access_Management')" :handler="() => { fiscalAccess(fiscalGridSelectedRow) }" icon="user-lock" iconCss="red-icon" :shortcut="shortcuts.access"></menu-item>
				<menu-item :title="$t('change-log.f.change-log')" v-if="$nikan.checkPermission(['General_ChangeLog_List'])" :handler="() => { fiscalChangeLog(fiscalGridSelectedRow) }" icon="scroll" iconCss="red-icon" :shortcut="shortcuts.changeLog"></menu-item>
			</context-menu>
			<context-menu :target="companyList">
				<menu-item :title="$t('company.new-company')" :handler="tryAddNewCompany" v-if="$nikan.checkPermission(['General_Company_Add'])" icon="plus" :shortcut="shortcuts.companyInsert"></menu-item>
				<menu-splitter></menu-splitter>
				<menu-item :title="$t('edit')" :handler="() => { editCompany(selectedCompany) }" v-if="$nikan.checkPermission(['General_Company_Edit'])" icon="edit" :shortcut="shortcuts.edit"></menu-item>
				<menu-item :title="$t('delete')" :handler="() => { deleteCompany(selectedCompany) }" v-if="$nikan.checkPermission(['General_Company_Delete'])" icon="trash" iconCss="red-icon" :shortcut="shortcuts.delete"></menu-item>
			</context-menu>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import { post } from '~/plugins/nikan-api'
	import CompanyModify from './company-modify'
	import Input from '~/components/general/nikan-input.vue'
	import $sc from '~/plugins/shortcut.collection.js'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import Endpoints from '@nikan/endpoints'
	import DataSource from '~/plugins/data-source'
	import PersianDate from 'persian-date'
	import BooleanView from '~/components/form/boolean-label'
	import { mapActions, mapGetters } from 'vuex'
	import AccessControl from '~/views/operation-roles/access-control'
	import ChangeLog from '~/components/form/change-log/change-log.vue'
	import FiscalPeriodSettings from '~/views/settings/settings-fiscal-periods'
	import FiscalPeriodModify from './fiscal-period-modify.vue'
	import companyImage from '~/assets/company.png'

	export default {
		name: 'fiscal-period-list',
		modal: {
			helpTag: 'FiscalPeriodList'
		},
		data() {
			return {
				companyImage: companyImage,
				selectedCompany: {},
				currentTab: '',
				companies: [],
				companySearchKeyword: '',
				fiscalSearchKeyword: '',
				fiscalGridSelectedRow: null,
				fiscalGridOptions: {
					id: this.$options.name,
					rowGroupPanelShow: false,
					groupIncludeTotalFooter: false,
					cellSelectionAggReport: false,
					sideBar: 'none',
					rowSelection: {
						mode: 'singleRow'
					},
					buttons: {
						addBtn: {
							displayOrder: 1,
							handler: this.tryAddNewFiscalPeriod,
							options: {
								visible: true,
								policyClaims: 'General_FiscalPeriod_Add'
							}
						},
						deleteBtn: {
							displayOrder: 5,
							handler: () => {
								if (this.fiscalGridSelectedRow != null) {
									this.deleteFiscal()
								}
								else {
									this.$toast(this.$t('company.m.select-fiscal'))
								}

							},
							options: {
								visible: true,
								policyClaims: 'General_FiscalPeriod_Delete'
							}
						},
						editBtn: {
							displayOrder: 2,
							handler: () => {
								if (this.fiscalGridSelectedRow != null) {
									this.editCurrentFiscalPeriod()
								}
								else {
									this.$toast(this.$t('company.m.select-fiscal'), { type: 'info' })
								}
							},
							class: "no-outline",
							type: 'nk-btn',
							options: {
								visible: true,
								isPrimary: false,
								icon: 'edit',
								tooltipEnabled: true,
								hideTitle: false,
								title: '',
								policyClaims: 'General_FiscalPeriod_Edit'
							}
						},
						accessBtn: {
							displayOrder: 3,
							handler: () => {
								if (this.fiscalGridSelectedRow != null) {
									this.fiscalAccess(this.fiscalGridSelectedRow)
								}
								else {
									this.$toast(this.$t('company.m.select-fiscal'), { type: 'info' })
								}
							},
							class: "no-outline",
							type: 'nk-btn',
							options: {
								visible: false,
								isPrimary: false,
								icon: 'user-lock',
								tooltipEnabled: true,
								hideTitle: false,
								title: '',
								policyClaims: 'General_Access_Management'
							}
						},
						logBtn: {
							displayOrder: 4,
							handler: () => {
								if (this.fiscalGridSelectedRow != null) {
									this.fiscalChangeLog()
								}
								else {
									this.$toast(this.$t('company.m.select-fiscal'), { type: 'info' })
								}
							},
							class: "no-outline",
							type: 'nk-btn',
							options: {
								visible: true,
								isPrimary: false,
								icon: 'scroll',
								tooltipEnabled: true,
								hideTitle: false,
								title: '',
								policyClaims: 'General_ChangeLog_List'
							}
						},
						settingsBtn: {
							displayOrder: 5,
							handler: () => {
								this.showModal({
									component: FiscalPeriodSettings,
								}).then((res) => { })
									.catch(() => { })
							},
							class: "no-outline",
							type: 'nk-btn',
							options: {
								visible: true,
								isPrimary: false,
								icon: 'cog',
								tooltipEnabled: true,
								hideTitle: true,
								title: this.$t('setting.fiscalPeriodSettings.title'),
								policyClaims: 'Settings_General_FiscalPeriod'
							}
						},
						refreshBtn: {
							displayOrder: 6,
							handler: () => {
								var wait = this.$wait(this.$refs.fiscalsWaitingZone)
								this.refreshPeriods({ force: true })
									.finally(() => wait.end())
							},
							class: "no-outline",
							type: 'nk-btn',
							options: {
								visible: true,
								isPrimary: false,
								icon: 'sync',
								tooltipEnabled: true,
								hideTitle: true,
								title: this.$t('trs.chq.oper.refresh'),
							}
						},
						deleteClosing: {
							displayOrder: 7,
							handler: () => {
								if (this.fiscalGridSelectedRow != null) {
									this.deleteFiscalClosing()
								}
								else {
									this.$toast(this.$t('company.m.select-fiscal'))
								}
							},
							class: "no-outline",
							type: 'nk-btn',
							options: {
								visible: true,
								disabled: () => !this.fiscalGridSelectedRow?.closed,
								isPrimary: false,
								icon: 'ban',
								tooltipEnabled: true,
								hideTitle: true,
								title: this.$t('fiscal.delete-closing'),
								policyClaims: 'General_FiscalPeriod_DeleteClosing'
							}
						}
					},

					columnDefs: [
						{
							field: 'rowNumber',
							headerName: this.$t('row-number'),
						},
						{
							field: 'name',
							headerName: this.$t('fiscal.f.name'),
							contentType: 'string',
							width: 100,
						},
						{
							field: 'startDate',
							headerName: this.$t('fiscal.f.startDate'),
							contentType: 'date',
							width: 100,
						},
						{
							field: 'endDate',
							headerName: this.$t('fiscal.f.endDate'),
							contentType: 'date',
							width: 100,
						},
						{
							field: 'description',
							headerName: this.$t('fiscal.f.description'),
							contentType: 'string',
							width: 100,
						},
						{
							field: 'createdBy',
							headerName: this.$t('Auditable.CreatedBy'),
							contentType: 'string',
							width: 100,
						},
						{
							field: 'created',
							headerName: this.$t('Auditable.Created'),
							contentType: 'date',
							width: 100,
						},
						{
							field: 'closed',
							headerName: this.$t('fiscal.f.closed'),
							contentType: 'enum',
							valueFormatter: data => typeof data.value === 'boolean' && this.$t(`boolean-yes-no.${data.value}`),
							cellRenderer: BooleanView,
							cellRendererParams: data => {
								return {
									options: {
										useColors: true,
										modelValue: data.data.closed
									},
								}
							},

						},

					],

				},
				fiscalTable: null,
				companyList: null,

				shortcuts: {
					companyInsert: $sc.find('new'),
					fiscalInsert: $sc.find('insert'),
					edit: $sc.find('edit'),
					delete: $sc.find('delete'),
					access: $sc.find('access-manager', 'fiscal'),
					changeLog: $sc.find('change-log'),
				},
				button_refresh: {
					title: this.$t('trs.chq.oper.refresh'),
					icon: 'sync',
					handle: () => {
						this.refreshCompanies()
					},
				},
				newCompanyButton: {
					title: this.$t('company.new-company'),
					shortcut: $sc.find('new'),
					icon: 'building',
					handle: (button, page, e) => {
						e.preventDefault()
						this.tryAddNewCompany()
					},
					policyClaims: 'General_Company_Add',
				},
				newPeriodButton: {
					title: this.$t('fiscal.new-fiscal'),
					shortcut: $sc.find('insert'),
					icon: 'coins',
					handle: (button, page, e) => {
						this.tryAddNewFiscalPeriod()
					},
					policyClaims: 'General_FiscalPeriod_Add',
				},
			}
		},
		computed: {
			...mapGetters({
				currentFiscalPeriod: 'appContext/getFiscalPeriod',
				getCurrentCompany: 'appContext/getCompany',
				fiscalPeriods: 'fiscalPeriods/getByCompanyId',
			}),
			filteredCompanies() {
				var companyFound = []
				var separatedSearchText = []
				separatedSearchText = this.companySearchKeyword.trim().split(' ')
				companyFound = this.companies || []

				for (var i = 0; i < separatedSearchText.length; i++) {
					companyFound = companyFound.filter(
						(x) =>
							`${x.name}`.indexOf(
								separatedSearchText[i]
							) > -1
					)
				}

				return companyFound
			},
			filteredFiscals() {
				var fiscalFound = []
				var separatedSearchText = []
				separatedSearchText = this.fiscalSearchKeyword.trim().split(' ')
				fiscalFound = this.fiscalPeriods((this.selectedCompany || {}).id) || []

				for (var i = 0; i < separatedSearchText.length; i++) {
					fiscalFound = fiscalFound.filter(
						(x) =>
							`${x.name} ${x.description}`.indexOf(separatedSearchText[i]) > -1
					)
				}

				fiscalFound = fiscalFound.sort2('startDate')

				if (fiscalFound > 0)
					this.selectFiscal(fiscalFound[0])

				return fiscalFound
			},
		},
		mounted() {
			this.refreshCompanies()
			this.fiscalTable = this.$refs['fiscalTable'].$el
			this.companyList = this.$refs['company-list-content']

			this.prepareWindow(this.$t('fiscal.title'), [
				this.newCompanyButton,
				this.newPeriodButton,
			])
		},
		methods: {
			...mapActions({
				refreshPeriods: 'fiscalPeriods/refresh',
			}),
			refreshCompanies(selectedCompany = this.getCurrentCompany) {

				var request = {
					PageIndex: 1,
					PageSize: 10,
				}

				var wait = this.$wait(this.$refs.companiesWaitingZone)

				post(Endpoints.getUrl('companies.list'), request)
					.then((result) => {
						wait.end()
						this.companies = result.data.items
						let index = this.companies.findIndex(x => x.id === selectedCompany.id)
						this.selectCompany(this.companies[index])
					})
					.catch(() => {
						wait.end()
					})
			},
			selectCompany(company) {
				if (company === this.selectedCompany)
					return

				this.selectedCompany = company

				this.defer(() => {
					$('.company-list-content').scrollTo($(this.$el).find(`.tiles li[data-id=${company.id}]`))
				}, 100)
			},
			deleteCompany(company) {
				dialog({
					title: this.$t('company.want-to-delete-company'),
					body: this.$t('company.warning-to-delete-company', {
						name: company.name,
					}),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.deleteCompanyConfirmed(company)
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			deleteCompanyConfirmed(company) {
				var url = Endpoints.getUrl('companies.delete', company.id)
				var wait = this.$wait(this.$refs.companiesWaitingZone)
				post(url, company)
					.then(result => {
						wait.end()
						this.refreshCompanies()
						this.$toast(this.$t('msg.delete-success'), { type: 'success' })
					})
					.catch(() => {
						wait.end()
					})
			},
			selectFiscal(fiscal) {
				this.fiscalGridSelectedRow = null
				this.fiscalGridSelectedRow = fiscal
			},
			deleteFiscal(fiscal) {
				if (!fiscal) fiscal = this.fiscalGridSelectedRow
				if (fiscal.id == this.currentFiscalPeriod.id) {
					dialog({
						title: this.$t('notifications.titles-warning'),
						body: this.$t('fiscal.delete-current-period-denied'),
						type: 'error',
					})
					return
				}

				dialog({
					title: this.$t('fiscal.want-to-delete-fiscal'),
					body: this.$t('fiscal.warning-to-delete-fiscal', { name: fiscal.name }),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.deleteFiscalConfirmed(fiscal)
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			deleteFiscalConfirmed(fiscal) {
				var url = Endpoints.getUrl('fiscalPeriod.delete', fiscal.id)
				var wait = this.$wait(this.$refs.fiscalsWaitingZone)

				post(url, fiscal)
					.then(result => {
						var wait2 = this.$wait(this.$refs.fiscalsWaitingZone)
						this.refreshPeriods()
							.finally(() => wait2.end())
						this.$toast(this.$t('msg.delete-success'), { type: 'success' })
						wait.end()
						this.$refs['company-list-content'].focus()
					})
					.catch(() => {
						wait.end()
					})
			},
			deleteFiscalClosing(fiscal) {
				if (!fiscal) fiscal = this.fiscalGridSelectedRow

				dialog({
					title: this.$t('fiscal.want-to-delete-closing'),
					body: this.$t('fiscal.warning-to-delete-closing', { name: fiscal.name }),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.deleteFiscalClosingConfirm(fiscal)
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			deleteFiscalClosingConfirm(fiscal) {
				var url = Endpoints.getUrl('closing.delete', fiscal.id)
				var wait = this.$wait(this.$refs.fiscalsWaitingZone)

				post(url, fiscal)
					.then(result => {
						var wait2 = this.$wait(this.$refs.fiscalsWaitingZone)
						this.refreshPeriods()
							.finally(() => wait2.end())
						this.$toast(this.$t('fiscal.delete-closing-success'), { type: 'success' })
						wait.end()
						this.$refs['company-list-content'].focus()
					})
					.catch(() => {
						wait.end()
					})
			},
			editCompany() {
				this.showModal({
					component: CompanyModify,
					data: _.cloneDeep(this.selectedCompany),
					options: {
						mode: 'edit'
					}
				})
					.then((response) => {
						this.refreshCompanies({ id: response.companyId })
						this.$refs['company-list-content'].focus()
					})
					.catch((reject) => {
						this.$refs['company-list-content'].focus()
					})
			},
			editCurrentFiscalPeriod() {
				const focus = () => $(this.$refs['fiscalTable'].$el).focus()
				this.showModal({
					component: FiscalPeriodModify,
					data: _.cloneDeep(this.fiscalGridSelectedRow),
					options: {
						companyId: this.selectedCompany.id
					}
				})
					.then((response) => {
						var wait = this.$wait(this.$refs.fiscalsWaitingZone)
						this.refreshPeriods().then(() => focus()).finally(() => wait.end())
					})
					.catch((reject) => {
						focus()
					})
			},
			tryAddNewCompany() {
				this.showModal({
					component: CompanyModify,
				})
					.then(response => {
						this.refreshCompanies({ id: response.companyId })
						var wait = this.$wait(this.$refs.fiscalsWaitingZone)
						this.refreshPeriods().then(() => {
						}).finally(() => wait.end())
						this.$refs['company-list-content'].focus()
					})
					.catch(() => {
						this.$refs['company-list-content'].focus()
					})
			},
			tryAddNewFiscalPeriod() {
				this.showModal({
					component: FiscalPeriodModify,
					options: {
						companyId: this.selectedCompany.id
					}
				})
					.then((response) => {
						var wait = this.$wait(this.$refs.fiscalsWaitingZone)
						this.refreshPeriods().then(() => {
							$(this.$refs['fiscalTable'].$el).focus()
							this.fiscalGridSelectedRow = response
						}).finally(() => wait.end())
					})
					.catch(() => {
						$(this.$refs['fiscalTable'].$el).focus()
					})
			},
			showSelectedCompany() {
				if (this.selectedCompany != null) {
					$('.company-list-content').scrollTo(
						$(this.$el).find(`.tiles li[data-id=${this.selectedCompany.id}]`)
					)
				}
			},
			companySearchKeywordChanged() {
				this.defer(this.showSelectedCompany, 50)
			},
			companyAccess(company) {
				this.showModal({
					component: AccessControl,
					data: {
						prefix: 'General_Company',
						accessData: {
							entityId: company.id,
							entityType: 'Company',
							objectDescription: 'شرکت ' + company.name,
						},
					},
				})
					.then((node) => { })
					.catch(() => { })
			},
			companyChangeLog(company) {
				let entityTitle = this.$t('change-log.f.company-change-log', {
					company: company.name,
				})
				this.showModal({
					component: ChangeLog,
					options: {
						entityTitle: entityTitle,
						companyId: company.id,
					},
				})
					.then((node) => { })
					.catch(() => { })
			},
			fiscalChangeLog(fiscal) {
				if (!fiscal) fiscal = this.fiscalGridSelectedRow
				let entityTitle = this.$t('change-log.f.fiscal-change-log', {
					fiscal: fiscal.name,
				})
				this.showModal({
					component: ChangeLog,
					options: {
						entityTitle: entityTitle,
						entityId: fiscal.id,
						entityType: 'FiscalPeriod',
					},
				})
					.then((node) => { })
					.catch(() => { })
			},
			fiscalAccess(fiscal) {
				if (!fiscal) fiscal = this.fiscalGridSelectedRow
				this.showModal({
					component: AccessControl,
					data: {
						prefix: 'General_FiscalPeriod',
						accessData: {
							entityId: fiscal.id,
							entityType: 'FiscalPeriod',
							objectDescription: 'سال مالی ' + fiscal.name,
						},
					},
				})
					.then((node) => { })
					.catch(() => { })
			},
			subscribeKeys() {
				var $companies = $(this.$el).find('.company-list-content')
				var $fiscals = $(this.$el).find('.col-fiscals')

				// Company Key Handlers
				this.$keyHandler.Subscribe({
					name: 'company-edit',
					shortcut: this.shortcuts.edit,
					el: $companies,
					context: this,
					test: function () {
						return this.selectedCompany != null
					},
					handler: function (sender, e) {
						this.editCompany(this.selectedCompany)
						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'company-delete',
					shortcut: this.shortcuts.delete,
					el: $companies,
					context: this,
					test: function () {
						return this.selectedCompany != null
					},
					handler: function (sender, e) {
						this.deleteCompany(this.selectedCompany)
					},
				}),
					this.$keyHandler.Subscribe({
						name: 'company-change-log',
						shortcut: this.shortcuts.changeLog,
						el: $companies,
						context: this,
						test: function () {
							return this.selectedCompany != null
						},
						handler: function (sender, e) {
							this.companyChangeLog(this.selectedCompany)
						},
					})
				this.$keyHandler.Subscribe({
					name: 'company-search',
					shortcut: $sc.find('search'),
					el: $companies,
					context: this,
					handler: function (sender, e) {
						e.preventDefault()
						this.$refs['company-search-input'].focus()
					},
				})
				this.$keyHandler.Subscribe({
					name: 'company-fiscals-grid-enter',
					shortcut: $sc.find('grid-enter', 'fiscal'),
					el: $companies,
					context: this,
					handler: function (sender, e) {
						if (this.filteredFiscals.length > 0) {
							$(this.$refs['fiscalTable'].$el).focus()
						}

						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'company-grid-up',
					shortcut: $sc.find('grid-up', 'fiscal'),
					el: $companies,
					context: this,
					handler: function (sender, e) {
						e.preventDefault()

						if (this.selectedCompany == null) {
							return
						}

						var index = this.filteredCompanies.findIndex(
							(item) => item.id === this.selectedCompany.id
						)
						index -= 1

						if (index >= 0) {
							this.selectCompany(this.filteredCompanies[index])
						} else {
							this.$refs['company-search-input'].focus()
						}

						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'company-grid-down',
					shortcut: $sc.find('grid-down', 'fiscal'),
					el: $companies,
					context: this,
					handler: function (sender, e) {
						e.preventDefault()

						if (this.selectedCompany == null) {
							return
						}

						var index = this.filteredCompanies.findIndex(
							(item) => item.id === this.selectedCompany.id
						)
						index += 1

						if (index < this.filteredCompanies.length) {
							this.selectCompany(this.filteredCompanies[index])
						}

						return true
					},
				})

				// Fiscal Period Key Handlers
				this.$keyHandler.Subscribe({
					name: 'fiscal-period-exit-grid',
					shortcut: $sc.find('exit-grid', 'fiscal'),
					el: $fiscals,
					context: this,
					handler: function (sender, e) {
						$(this.$el).find('.company-list-content').focus()
						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'fiscals-search',
					shortcut: $sc.find('search'),
					el: $fiscals,
					context: this,
					handler: function (sender, e) {
						e.preventDefault()
						$(this.$refs['fiscal-search-input']).focus()
					},
				})
				this.$keyHandler.Subscribe({
					name: 'edit-fiscal',
					shortcut: this.shortcuts.edit,
					el: $fiscals,
					context: this,
					handler: function (sender, e) {
						this.editCurrentFiscalPeriod()
						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'delete-fiscal',
					shortcut: this.shortcuts.delete,
					el: $fiscals,
					context: this,
					handler: function (sender, e) {
						this.deleteFiscal(this.fiscalGridSelectedRow)
					},
				})
				this.$keyHandler.Subscribe({
					name: 'fiscal-grid-up',
					shortcut: $sc.find('grid-up', 'fiscal'),
					el: $fiscals,
					context: this,
					handler: function (sender, e) {
						$(this.$refs['fiscalTable'].$el).focus()
						// arrow up and down handled in grid itself.
						// so we need to stop triggering Tab arrow up/down key handlers
						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'fiscal-grid-down',
					shortcut: $sc.find('grid-down', 'fiscal'),
					el: $fiscals,
					context: this,
					handler: function (sender, e) {
						$(this.$refs['fiscalTable'].$el).focus()
						// arrow up and down handled in grid itself.
						// so we need to stop triggering Tab arrow up/down key handlers
						return true
					},
				})

				// Other Key Handlers
				this.$keyHandler.Subscribe({
					name: 'company-search-exit',
					shortcut: $sc.find('exit'),
					el: this.$refs['company-search-input'],
					context: this,
					handler: function (sender, e) {
						this.companySearchKeyword = ''
						this.defer(this.showSelectedCompany, 50)
						this.$refs['company-list-content'].focus()
						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'fiscal-search-exit',
					shortcut: $sc.find('exit'),
					el: this.$refs['fiscal-search-input'],
					context: this,
					handler: function (sender, e) {
						this.fiscalSearchKeyword = ''
						$(this.$refs['fiscalTable'].$el).focus()
						return true
					},
				})
			},
		},
	}
</script>
<style>

	.company-list-content,
	.fiscal-list-content {
		flex: 1;
	}

	.delete-btn {
		color: red !important;
	}

	.delete-btn:hover {
		background-color: red !important;
		color: white !important;
	}

	.company-tile .buttons {
		max-height: 0;
		overflow: hidden;
		height: auto;
	}

	.company-tile.selected .buttons {
		transition: max-height 300ms ease-in-out;
		max-height: 1000px;
	}
</style>
